'use client';
import { useEffect } from 'react';
import { useDropdownContext } from '.';
import { CLOSE_ALL_ACTION } from './useSingleDropdown';

function useCloseModalsOnEscape() {
  const { dispatch, state } = useDropdownContext();

  useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      const modalsAreOpen =
        state.isShowingSearch || state.isShowingMobileNav || state.isShowingDesktopNav;
      if (event.key === 'Escape' && modalsAreOpen) {
        dispatch(CLOSE_ALL_ACTION);
      }
    }

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [dispatch, state]);
}

export function EscapeHandlerProvider({ children }: { children: React.ReactNode }) {
  useCloseModalsOnEscape();

  return <>{children}</>;
}
